import { AfterViewInit, Component, Inject, OnInit, ViewChild } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { DefaultValuesService } from "../../services/defaultvalues.service";
import { Utils } from "../../utils/utils";
import { ProvisioningTemplateComponent } from "./provisioningratemplate/provisioningratemplate.component";
import { AllowedActionControllerTypeComponent } from "./allowedactionscontrollertype/allowedactionscontrollertype.component";
import { MatTabGroup } from "@angular/material/tabs";

@Component({
    selector: "remoteactions",
    templateUrl: './remoteactions.component.html',
    styleUrls: ['../../style/container-tab-list.component.less', './remoteactions.component.less'],
    standalone: false
})

export class RemoteActionsComponent implements OnInit, AfterViewInit {

    commandList: Command[] = [];
    @ViewChild('provisioningTemplateComponent', { static: true }) provisioningTemplateComponent!: ProvisioningTemplateComponent;
    @ViewChild('allowedActionsControllerTypeComponent', { static: false }) allowedActionsControllerTypeComponent!: AllowedActionControllerTypeComponent;
    @ViewChild('tabGroup') tabGroup!: MatTabGroup;
    subscriptionLanguage: any;
    isTenantRemoteActionAdminUser!: boolean;
    isControllerRemoteActionAdminUser!: boolean;

    constructor(
        private readonly http: HttpClient
        , @Inject('BASE_URL') private readonly baseUrl: string
        , public readonly defaults: DefaultValuesService
    ) {
    }
    
    ngOnInit(): void {
        this.isTenantRemoteActionAdminUser = this.defaults.isTenantRemoteActionAdminUser;
        this.isControllerRemoteActionAdminUser = this.defaults.isControllerRemoteActionAdminUser;
        
        this.getCommands();
        this.subscriptionLanguage = this.defaults.languageMessageChanges$.subscribe(() => {
            this.getCommands();
        });
    }

    ngAfterViewInit() {
        this.defaults.defaultComponentTab(this)
    }

    onReload() {
        this.getCommands();
    }

    onReloadCommandTemplate() {
        this.provisioningTemplateComponent.getCommandConfigTemplate();
    }

    public showTabsByAllowedActionCT(command: string): boolean {
        if (this.allowedActionsControllerTypeComponent) {
            const exists = this.allowedActionsControllerTypeComponent.mergedList.find(x => x.CommandName === command)
            if (exists?.IsSupported === true)
                return true;
            else
                return false;
        }
        return false;
    }

    getCommands() {
        Utils.httpGetCommands(
            this.http
            , this.baseUrl
            , this
            , function (tthis: RemoteActionsComponent, list: Command[]) {
                tthis.commandList = list;
            }
        );
    }

    isEditable(category: string): boolean {
        return category?.toLocaleUpperCase() !== 'MAX DEVICE' &&
                category?.toLocaleUpperCase() !== 'DES' &&
                category?.toLocaleUpperCase() !== 'XPU'
    }
}

